<!--=============================
=            LOADING            =
==============================-->

<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Loading</div>
      </base-header>
    </v-row>
    <v-row>
      <v-col class="col-12 col-md-4 col-sm-12">

        <base-card>
          <div slot="card-header">Circle</div>
          <div slot="card-subheader">In consectetur et anim amet. </div>
          <div slot="card-body">
            <v-row class="justify-center mx-auto" style="height:100px">
              <Spinner name="circle" color="blue" />
            </v-row>
          </div>
        </base-card>

      </v-col>
      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">Wave</div>
          <div slot="card-subheader">In consectetur et anim amet. </div>
          <div slot="card-body">
            <v-row class="justify-center mx-auto" style="height:100px">
              <Spinner name="wave" color="#c6f260" />
            </v-row>
          </div>
        </base-card>
      </v-col>
      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">Ball Triangule path</div>
          <div slot="card-subheader">In consectetur et anim amet. </div>
          <div slot="card-body">
            <v-row class="justify-center mx-auto" style="height:100px">
              <Spinner name="ball-triangle-path" color="#dd6174" />
            </v-row>
          </div>
        </base-card>
      </v-col>

      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">Three Bounce</div>
          <div slot="card-subheader">In consectetur et anim amet. </div>
          <div slot="card-body">
            <v-row class="justify-center mx-auto" style="height:100px">
              <Spinner name="three-bounce" color="#19aa40" />
            </v-row>
          </div>
        </base-card>

      </v-col>

      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">Rotate Plane</div>
          <div slot="card-subheader">In consectetur et anim amet. </div>
          <div slot="card-body">
            <v-row class="justify-center mx-auto" style="height:100px">
              <Spinner name="rotating-plane" color="#46fcde" />
            </v-row>
          </div>
        </base-card>

      </v-col>
      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">Wordpress</div>
          <div slot="card-subheader">In consectetur et anim amet. </div>
          <div slot="card-body">
            <v-row class="justify-center mx-auto" style="height:100px">
              <Spinner name="wordpress" color="#ff8b5e" />
            </v-row>
          </div>
        </base-card>

      </v-col>
      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">Ball Scale Multiple</div>
          <div slot="card-subheader">In consectetur et anim amet. </div>
          <div slot="card-body">
            <v-row class="justify-center mx-auto" style="height:100px">
              <Spinner name="ball-scale-multiple" color="#8769c6" />
              </v-card>
            </v-row>
          </div>
        </base-card>

      </v-col>

      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">Fading Circle</div>
          <div slot="card-subheader">In consectetur et anim amet. </div>
          <div slot="card-body">
            <v-row class="justify-center mx-auto" style="height:100px">
              <Spinner name="fading-circle" color="#dd6174" />
            </v-row>
          </div>
        </base-card>

      </v-col>
      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">Pulse</div>
          <div slot="card-subheader">In consectetur et anim amet. </div>
          <div slot="card-body">
            <v-row class="justify-center mx-auto" style="height:100px">
              <Spinner name="pulse" color="#7aefc0" />
            </v-row>
          </div>
        </base-card>

      </v-col>
      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">Circle Solid spin</div>
          <div slot="card-subheader">In consectetur et anim amet. </div>
          <div slot="card-body">
            <v-row class="justify-center mx-auto" style="height:100px">
              <Spinner name="circle-solid-spin" color="#2d68af" />
            </v-row>
          </div>
        </base-card>

      </v-col>

      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">Folfing Cube</div>
          <div slot="card-subheader">In consectetur et anim amet. </div>
          <div slot="card-body">
            <v-row class="justify-center mx-auto" style="height:100px">
              <Spinner name="folding-cube" color="#e26bef" />
            </v-row>
          </div>
        </base-card>

      </v-col>
      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">Cube Grid</div>
          <div slot="card-subheader">In consectetur et anim amet. </div>
          <div slot="card-body">
            <v-row class="justify-center mx-auto" style="height:100px">
              <Spinner name="cube-grid" color="#e00030" />
            </v-row>
          </div>
        </base-card>

      </v-col>
      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header"> Heart</div>
          <div slot="card-subheader">In consectetur et anim amet. </div>
          <div slot="card-body">
            <v-row class="justify-center mx-auto" style="height:100px">
              <Spinner name="heart" color="#e26bef" />
            </v-row>
          </div>
        </base-card>

      </v-col>

      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">Ball Pulse Rise</div>
          <div slot="card-subheader">In consectetur et anim amet. </div>
          <div slot="card-body">
            <v-row class="justify-center mx-auto" style="height:100px">
              <Spinner name="ball-pulse-rise" color="#49fc5e" />
            </v-row>
          </div>
        </base-card>

      </v-col>
      <v-col class="col-12 col-md-4 col-sm-12">
        <base-card>
          <div slot="card-header">Line Spin Fade Loader</div>
          <div slot="card-subheader">In consectetur et anim amet. </div>
          <div slot="card-body">
            <v-row class="justify-center mx-auto" style="height:100px">
              <Spinner name="line-spin-fade-loader" color="#e26bef" />
            </v-row>
          </div>
        </base-card>

      </v-col>

    </v-row>



  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },

  }
</script>

<!--====  End of LOADING  ====-->